module.exports = __webpack_public_path__ + "static/img/COC2023-24.b901a80.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-24.png
// module id = MfLH
// module chunks = 0